<script>
    export default {
        mounted() {
            let q = this.$route.query;
            localStorage.setItem('access_token',q.token);
            this.$store.state.access_token = q.token;


            this.$store.dispatch("GET_PROFILE");
            this.$store.dispatch("GET_LIB");

            this.$router.push(q.redirect);
        }
    }
</script>